import { Links } from '@/_data/links';
import { Button, Space } from 'antd';
import styles from './CustomDesignWidget.module.css';

export default function CustomDesignWidget() {
   return (
      <>
         <div
            className={styles.container}
            style={{
               display: 'flex',
               flexDirection: 'column',
               padding: '32px',
               background: 'linear-gradient(90deg, #9A88F4 7.00%, #DAAFF4 100%)',
               borderRadius: '20px',
            }}
         >
            <div className={styles.content}>
               <Space direction="vertical" size={8} className={styles.text}>
                  <h3>Hire our team</h3>
                  <p>
                     Get your presentation custom designed by us, starting at just $5 per slide, based on this template
                     or any other style needed
                  </p>
               </Space>
               <div className={styles.callToAction}>
                  <Button type="default" size="large" href={Links.studio} target="_blank" style={{ color: '#7164B6' }}>
                     Request your design
                  </Button>
                  <span className={styles.price}>
                     Starting at <strong>$5</strong>
                  </span>
               </div>
            </div>
         </div>
      </>
   );
}
